import React, { useContext, useMemo, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import LogRocket from 'logrocket';

import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { Checkbox } from 'ui-components/components/checkbox';
import { testId } from 'ui-components/services/testid-service';

import { ProductDetailsModalHeader } from './header';
import { ProductDetailsSubHeaderMessage } from './sub-header-message';
import { ProductDetailsProductInfo } from './product-info';
import { ProductDetailsModalFooter } from './footer';
import { tabs, general, productActiveShippingLocations } from './tabs';

import { ProductDetailsContext } from '../context';

import { messages } from '../messages';

import style from '../style.module.less';

export const ProductDetailsModalContent = () => {
  const {
    closeModal,
    selectedTab = general.id,
    setSelectedTab,
    isActive,
    setIsActive,
    userHasPermission,
    isSmartRoutingEnabled,
  } = useContext(ProductDetailsContext);

  const additionalSettings = useMemo(() => {
    return {
      isSmartRoutingEnabled,
    };
  }, [isSmartRoutingEnabled]);

  const selectedTabRender = tabs.find((tab) => tab.id === selectedTab)?.render ?? general.render;
  const accessibleTabs = useSelector((state) => tabs.filter((tab) => tab.shouldRender(state, additionalSettings)));

  const handleOnClick = useCallback(
    (tabId) => {
      if (tabId === productActiveShippingLocations.id) {
        // Want to see interaction with this Action Button versus the Locations tab
        const environment = process.env.NODE_ENV || 'development'; // "development" or "production"
        LogRocket.track('INTERACT_WITH_ACTIVE_SHIPPING_LOCATIONS_TAB', {
          env: environment,
        });
      }
      setSelectedTab(tabId);
    },
    [setSelectedTab],
  );

  return (
    <>
      <ModalHeader className={style['header-wrapper']} closeModal={closeModal}>
        <ProductDetailsModalHeader />
      </ModalHeader>
      <ModalBody className={style['product-details-body']}>
        <div className={style['content-header-wrapper']}>
          <ProductDetailsSubHeaderMessage />
          <ProductDetailsProductInfo />
          <div className={style.tabs}>
            {accessibleTabs.map((tab) => {
              const isSelected = tab.id === selectedTab;
              return (
                <div
                  key={tab.id}
                  className={isSelected ? style.selected : null}
                  onClick={() => handleOnClick(tab.id)}
                  {...testId(`product-details-tab-${tab.id}`)}
                >
                  {tab.name()}
                </div>
              );
            })}
            <Checkbox
              checked={isActive}
              className={style['active-input']}
              disabled={!userHasPermission}
              label={<FormattedMessage {...messages.activeLabel} />}
              onChange={setIsActive}
            />
          </div>
        </div>
        <div className={style['tab-wrapper']}>{selectedTabRender()}</div>
      </ModalBody>
      <ModalFooter className={style['footer-wrapper']}>
        <ProductDetailsModalFooter />
      </ModalFooter>
    </>
  );
};
